import { DeckList } from "@/components/decks/DeckList";

const DeckListRoute = () => {
  return (
    <div className="w-full h-full">
      <div className="w-full max-w-7xl mx-auto px-4">
        <DeckList />
      </div>
    </div>
  );
};

export { DeckListRoute }; 